import React from 'react';
import PropTypes from 'prop-types';
import Tippy from '@tippyjs/react';
import { followCursor } from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import styles from './Tooltip.module.scss';

const Tooltip = ({ content, children, position, spanClassName, ...rest }) => {
  if (!content) {
    return children;
  }

  return (
    <Tippy
      content={content}
      plugins={[followCursor]}
      followCursor
      arrow
      placement={position}
      theme="light"
      offset={[0, 5]}
      duration={[200, 0]}
      {...rest}
    >
      <span className={spanClassName}>{children || (<i className={`la la-info-circle ${styles.icon}`} />)}</span>
    </Tippy>
  );
};

Tooltip.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node,
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  spanClassName: PropTypes.string,
};

Tooltip.defaultProps = {
  content: null,
  position: 'top',
  children: null,
  spanClassName: null,
};

export default Tooltip;
